<template>
	<el-dialog title="任务详情" :visible.sync="dialogVisible" append-to-body width="420px" :before-close="handleClose">
		<div>
			<el-card class="card-container" shadow="never">
				<div class="bold font16">{{ parames.source == 1 ? '我的订单' : '团队订单' }}</div>

				<div class="flex align-center m-t-15"><span class="text-red m-r-3">*</span>所属平台：<span class="m-l-10">{{
						parames.params_json.type_new|getPlatformName
						}}</span></div>
				<div class="flex align-center m-t-15"><span class="text-red m-r-3">*</span>订单状态：<span class="m-l-10">{{
						parames.params_json.status|getStatus }}</span></div>
				<div class="flex align-center m-t-15"><span class="text-red m-r-3">*</span>付款时间：<span class="m-l-10">{{
						parames.params_json.create_start>0?(formatTime(parames.params_json.create_start * 1000,
						'Y-M-D')):''
						}} - {{
						parames.params_json.create_end>0?(formatTime(parames.params_json.create_end * 1000, 'Y-M-D')):
						'' }}</span></div>
			</el-card>

		</div>
	</el-dialog>
</template>

<script>
import { ENUM } from '@/utils/enum'
import { formatTime } from '@/utils/timeTransfer'
export default {
	props: {
		isShow: {
			type: Boolean,
			default: false
		},
		parames: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		dialogVisible: {
			get() {
				return this.isShow
			},
			set(val) {

			}
		},
	},
	data() {
		return {
			info: {}
		}
	},
	filters: {
		getPlatformName(val) {
			let arr = ENUM.PLAT_LIST
			let i = arr.findIndex(item => item.value == val)
			if (i != -1) {
				return arr[i].label
			} else {
				return '-'
			}
		},
		getStatus(val) {
			let arr = ENUM.STATUS_LIST
			let i = arr.findIndex(item => item.value == val)
			if (i != -1) {
				return arr[i].label
			} else {
				return '-'
			}
		},
	},
	mounted() {

	},
	methods: {
		formatTime,
		handleClose() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
	padding: 0 20px 30px;
}

.ptw-content {
	padding: 10px 20px;
	background-color: #f5f5f5;
	border-radius: 4px;
}

.copy-button {
	width: 100%;
}

.open-link-button {
	width: 100%;
	margin-bottom: 10px;
}

.copy-link-button {
	width: 100%;
	margin-left: 0 !important;
}
</style>
